// 分析指标三联动
export const ANALYSE_OPTIONS_LIST = [{
  value: 'customer',
  label: '受众',
  children: [{
    value: 'peopleNum',
    label: '数量',
    children: [{
      value: 'sum',
      label: '总和',
      disabled: false
    }]
  }]
}, {
  value: 'statistic',
  label: '统计',
  children: [{
    value: 'activity',
    label: '活跃度',
    children: [{
      value: 'sum',
      label: '总和',
      disabled: false
    }, {
      value: 'avg',
      label: '平均值',
      disabled: false
    }, {
      value: 'min',
      label: '最小值',
      disabled: false
    }, {
      value: 'max',
      label: '最大值',
      disabled: false
    }]
  }, {
    value: 'seven_activity',
    label: '7天活跃度',
    children: [{
      value: 'sum',
      label: '总和',
      disabled: false
    }, {
      value: 'avg',
      label: '平均值',
      disabled: false
    }, {
      value: 'min',
      label: '最小值',
      disabled: false
    }, {
      value: 'max',
      label: '最大值',
      disabled: false
    }]
  }, {
    value: 'thirty_activity',
    label: '30天活跃度',
    children: [{
      value: 'sum',
      label: '总和',
      disabled: false
    }, {
      value: 'avg',
      label: '平均值',
      disabled: false
    }, {
      value: 'min',
      label: '最小值',
      disabled: false
    }, {
      value: 'max',
      label: '最大值',
      disabled: false
    }]
  }]
}]

// 分析维度三联动 
export function ANALYSE_DIMENSION_OPTIONS_FUN() {
  return [{
    value: '',
    label: '无',
    disabled: true
  },
  {
    value: 'attr',
    label: '受众属性',
    children: []
  },
  {
    value: 'key_indicators',
    label: '受众关键指标',
    children: [{
      value: 'activity',
      label: '活跃度'
    }, {
      value: 'seven_activity',
      label: '7天活跃度'
    }, {
      value: 'thirty_activity',
      label: '30天活跃度'
    }, {
      value: 'value_scoring',
      label: '价值评分'
    }, {
      value: 'score',
      label: '资料评分'
    }]
  }
  ]
}

// 受众分析（客户分析）  分析维度的初始值 analyseDimensionDataFun
export function ANALYSE_DIMENSION_DATA_FUN() {
  return [{
    dimension: [''],
    sectionFormLine: {
      sectionList: [{
        minValue: '-∞',
        maxValue: '',
        name: '',
        disabled: false, // 控制是否展示删除按钮
        showSymbol: true, // 控制是否展示+∞
        index: 0
      }],
    },
    showSetValue: false, // 设置数值区间找个小标志是否展示
    showSetValueDialog: false, // 设置数值区间弹窗
  }]
}
//analyseDimensionDataINIT

export const ANALYSE_DIMENSION_DATA_INIT = [{
  dimension: [''],
  sectionFormLine: {
    sectionList: [{
      minValue: '-∞',
      maxValue: '',
      name: '',
      disabled: false, // 控制是否展示删除按钮
      showSymbol: true, // 控制是否展示+∞
      index: 0
    }],
  },
  showSetValue: false, // 设置数值区间找个小标志是否展示
  showSetValueDialog: false, // 设置数值区间弹窗
}]

export const SECTION_LIST_INIT = [{
  minValue: '-∞',
  maxValue: '',
  name: '',
  disabled: false, // 控制是否展示删除按钮
  showSymbol: true, // 控制是否展示+∞
  index: 0
}]



// 行为分析-分析维度

export function ANALYSE_SE_QUO_INIT_OPS() {
  return [{
    value: 'total_number_people',
    label: '受众总和',
    disabled: false
  }, {
    value: 'total_number_times',
    label: '次数总和',
    disabled: false
  }, {
    value: 'amount_of_price',
    label: '金额总和',
    disabled: true,
    children: []
  }, {
    value: 'amount_of_events',
    label: '数量总和',
    disabled: true,
    children: []
  }, {
    value: 'total_activity',
    label: '活跃度总和',
    disabled: false
  }]

}
// 行为分析-分析维度
export function BEHAVIOR_DIMENSION_OPS() {
  return [{
    value: '',
    label: '无',
    disabled: true
  },
  {
    value: 'customerAttrs',
    label: '受众属性',
    disabled: false,
    children: [{
      value: 'peopleNum',
      label: '人数',
      children: []
    }]
  }, {
    value: 'eventAttrs',
    label: '事件',
    disabled: true,
    children: []
  }
  ]
}

// 当分析维度是一下几个属性的时候，显示设置按钮  进货数量，进货次数，进货金额，扫码商品数，扫码人数，扫码率，动销率，活跃度
export const ATTR_LIST = [
  'purchase_qty', // 进货量(瓶) 
  'purchase_times', // 进货次数 
  'purchase_amount', // 进货金额(元)
  'scancode_good_qty', // 扫码商品数
  'scancode_people_num', // 扫码人数
  'scancode_rate', // 扫码率
  'movable_pin_rate', // 动销率 
  'activity_year' //活跃度 
]
// 传给后端的入参标记
// -∞
export const NEGATIVE_INFINITY = '-9223372036854775808'
// +∞
export const INFINITY = '9223372036854775807'

// txt --- relation
export const TXT_RELATIONSHIP_LIST = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'contain',
  label: '包含'
},
{
  value: 'not_contain',
  label: '不包含'
},
{
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
}
]

// money -- relation 
export const MONEY_RELATIONSHIP_LIST = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'gt',
  label: '大于'
},
{
  value: 'gte',
  label: '大于等于'
},
{
  value: 'lt',
  label: '小于'
},
{
  value: 'lte',
  label: '小于等于'
},
{
  value: 'gtele',
  label: '区间'
}
]
// number -- relation 
export const NUMBER_RELATIONSHIP_LIST = [{
  value: 'equal',
  label: '等于'
},
{
  value: 'not_equal',
  label: '不等于'
},
{
  value: 'empty',
  label: '为空'
},
{
  value: 'not_empty',
  label: '不为空'
}
]
// dictionary -- relation 
export const DICTIONARY_RELATIONSHIP_LIST = [{
  value: 'equal',
  label: '等于'
}]
// 行为分析 - 限制事件属性的下拉
export const RELATIONSHIP_OBJ = {
  'txt': TXT_RELATIONSHIP_LIST,
  'money': MONEY_RELATIONSHIP_LIST,
  'number': NUMBER_RELATIONSHIP_LIST,
  'dictionary': DICTIONARY_RELATIONSHIP_LIST
}